import { uuid } from "../uuid";
import { resolvePhoneColumns } from "./resolvePhoneColumns";

export const useParseCsvData = (csvData: string) => {
  const lines = csvData.split("\n");
  const parsedData = lines.map((line) => {
    const [name, email, ...rest] = line.split(",");
    const { phone, phone_country } = resolvePhoneColumns(rest);

    return {
      email: email ? email.trim() : "",
      name: name ? name.trim() : "",
      displayName: name ? name.trim() : "",
      user_id: uuid(),
      id: uuid(),
      phone,
      phone_country,
    };
  });

  return parsedData.filter(
    (entry) => (entry.name && entry.email) || entry.email,
  );
};
